import { Currency } from '@40seas/models';
import { EnumSchema, FromSchema, ZodDate } from 'libs/entities/common/src/SchemaOperations';
import { z } from 'zod';

export const CreditReviewFinancialStatementSummarySchema = z.object({
    netSales: z.number().optional(),
    otherOperationIncome: z.number().optional(),
    latestBalance: z.number().optional(),
    totalDebt: z.number().optional(),
    netIncome: z.number().optional(),
    employees: z.number().optional(),
    cashFlow: z.number().optional(),
    currency: EnumSchema(Currency).optional(),
    yearEndDate: ZodDate.optional(),
});

export class CreditReviewFinancialStatementSummary extends FromSchema(CreditReviewFinancialStatementSummarySchema) {
    netSales?: number;
    otherOperationIncome?: number;
    latestBalance?: number;
    totalDebt?: number;
    netIncome?: number;
    employees?: number;
    cashFlow?: number;
    currency?: Currency;
    yearEndDate?: Date;
}

export const CreditReviewFinancialStatementSchema = z
    .object({
        summary: CreditReviewFinancialStatementSummarySchema.optional(),
        financialStatement: z.any().optional(),
        localFinancialStatement: z.any().optional(),
    })
    .strict();

export class CreditReviewFinancialStatement extends FromSchema(CreditReviewFinancialStatementSchema) {
    summary: CreditReviewFinancialStatementSummary;
    financialStatement?: any;
    localFinancialStatement?: any;
}
